import { useVoiceOptions } from '@startupquickstart/frontend';
import { useEffect, useState } from 'react';
import { AiGenerateDialog } from '@/components/ai-job/AiGenerateDialog';

interface GenerateThemeTranslationVoiceoversDialogProps {
  attractionId: string;
  themeId: string;
  translationId: string;
  open: boolean;
  onClose: () => void;
}

export function GenerateThemeTranslationVoiceoversDialog({
  attractionId,
  themeId,
  translationId,
  open,
  onClose,
}: GenerateThemeTranslationVoiceoversDialogProps) {
  const { voices, isLoading: voicesLoading } = useVoiceOptions();
  const [voiceoverType, setVoiceoverType] = useState<
    'both' | 'description' | 'long_description'
  >('both');
  const [voice, setVoice] = useState<string>('alloy');

  useEffect(() => {
    if (voices.length === 0) return;
    if (!voices.some((v) => v.value === voice)) {
      setVoice(voices[0].value);
    }
  }, [voices, voice]);

  return (
    <AiGenerateDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title="Generate Translation Voiceovers"
      submitLabel="Generate Voiceovers"
      description="Generate AI-powered voiceovers from the translated theme descriptions using AI text-to-speech."
      endpoint={`/attractions/${attractionId}/themes/${themeId}/translations/${translationId}/generate-voiceovers`}
      invalidateKeys={[['Translation']]}
      successMessage="Theme translation voiceovers generated successfully"
      errorFallback="Failed to generate theme translation voiceovers"
      buildPayload={() => ({ voiceoverType, voice })}
    >
      <div>
        <label htmlFor="voiceoverType" className="block text-sm font-medium mb-2">
          Voiceover Type <span className="text-destructive">*</span>
        </label>
        <select
          id="voiceoverType"
          required
          className="w-full px-3 py-2 border rounded-md"
          value={voiceoverType}
          onChange={(e) =>
            setVoiceoverType(
              e.target.value as 'both' | 'description' | 'long_description',
            )
          }
        >
          <option value="both">Both (Short + Long)</option>
          <option value="description">Short Description Only</option>
          <option value="long_description">Long Description Only</option>
        </select>
      </div>

      <div>
        <label htmlFor="voice" className="block text-sm font-medium mb-2">
          AI Voice <span className="text-destructive">*</span>
        </label>
        <select
          id="voice"
          required
          className="w-full px-3 py-2 border rounded-md"
          value={voice}
          onChange={(e) => setVoice(e.target.value)}
          disabled={voicesLoading}
        >
          {voices.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </AiGenerateDialog>
  );
}
